import React, { useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../../../backend/request";
import "../../../pages/Auditor/ActivityModalV2.css";

interface DropAuditModalProps {
  audit: any;
  onClose: () => void;
  onSuccess: () => void;
}

function DropAuditModal({ audit, onClose, onSuccess }: DropAuditModalProps) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    if (!reason.trim()) {
      toast.error("Please provide a reason for dropping the audit.");
      return;
    }
    setSubmitting(true);
    try {
      await api.put(`/api/v1/vendor_location_audits/${audit.id}`, {
        vendor_location_audit: {
          status: "dropped_audit",
          metadata: {
            drop_reason: reason.trim(),
            dropped_date: new Date().toISOString().split("T")[0],
          },
        },
      });
      toast.success("Audit has been dropped successfully.");
      onSuccess();
    } catch (error) {
      const errorMessage =
        (error && (error as any).response && (error as any).response.data && (error as any).response.data.message) ||
        "Failed to drop the audit.";
      toast.error(errorMessage);
    }
    setSubmitting(false);
  }

  return (
    <div className="ae-confirm-overlay">
      <div className="ae-confirm-dialog" style={{ width: 660, padding: 16, gap: 16, display: "flex", flexDirection: "column" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 20, fontWeight: 600, color: "#1E1E1E", lineHeight: 1.2 }}>
            Drop Audit
          </span>
          <button type="button" className="ae-confirm-close" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div style={{ height: 1, background: "#E6E6E6", width: "100%" }} />

        {/* Question */}
        <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 16, fontWeight: 600, color: "#1E1E1E", lineHeight: 1.2, margin: 0 }}>
          Are you sure you want to mark this audit as dropped?
        </p>

        {/* Reason field */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 14, fontWeight: 500, color: "#1E1E1E" }}>
            Reason for Dropping Audit<span style={{ color: "#EC221F" }}>*</span>
          </label>
          <textarea
            style={{
              width: "100%", height: 114, padding: "8px 12px",
              background: "#fff", border: "1px solid #D1D5DB", borderRadius: 8,
              fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 400,
              color: "#1E1E1E", lineHeight: 1.5, resize: "vertical", boxSizing: "border-box"
            }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Add your reason here"
          />
        </div>

        <div style={{ height: 1, background: "#E6E6E6", width: "100%" }} />

        {/* Footer */}
        <div style={{ display: "flex", gap: 24 }}>
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            style={{
              flex: 1, height: 40, background: "#F3F4F6", color: "#0F0F0F",
              border: "none", borderRadius: 8, fontFamily: "'Montserrat', sans-serif",
              fontSize: 14, fontWeight: 500, cursor: "pointer"
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={submitting}
            style={{
              flex: 1, height: 40, background: "#2965AD", color: "#fff",
              border: "none", borderRadius: 8, fontFamily: "'Montserrat', sans-serif",
              fontSize: 14, fontWeight: 500, cursor: "pointer"
            }}
          >
            {submitting ? "Dropping..." : "Yes"}
          </button>
        </div>

      </div>
    </div>
  );
}

export default DropAuditModal;
